var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"cerrando-butacas","title":"Cerrando butacas"},on:{"close":() => _vm.confirmar()}},[_c('h3',[_vm._v("Se están cerrando las butacas de los abonados, cuando se hayan cerrado recibirás una notificación")]),_c('Button',{staticClass:"mt-2",on:{"click":function($event){return _vm.confirmar()}}},[_vm._v("Aceptar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }